import { Navbar } from "@/components/sections/Navbar";
import { Footer } from "@/components/sections/Footer";
import { PackageCheck, Clock, ShieldCheck, Mail } from "lucide-react";

export const RetourPage = () => {
  return (
    <>
      <Navbar />
      
      <div className="min-h-screen bg-gradient-to-b from-background via-muted/10 to-background pt-32 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Hero Section */}
            <div className="text-center mb-16">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gold/10 mb-6">
                <PackageCheck className="w-10 h-10 text-gold" />
              </div>
              
              <h1 className="font-serif text-4xl md:text-5xl font-bold text-gold mb-6 text-glow">
                Retour- & Terugbetalingsbeleid
              </h1>
              
              <div className="w-16 h-1 bg-gradient-gold mx-auto mb-8" />
              
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Bij Lunssence streven we naar volledige tevredenheid van onze klanten
              </p>
            </div>

            {/* Nederlands Section */}
            <div className="bg-card rounded-2xl border-2 border-gold/20 p-8 md:p-12 shadow-lg mb-8">
              <div className="flex items-center gap-3 mb-8">
                <span className="text-4xl">🇳🇱</span>
                <h2 className="font-serif text-3xl font-bold text-primary">Nederlands</h2>
              </div>

              <div className="space-y-8">
                {/* Intro */}
                <div>
                  <p className="text-muted-foreground leading-relaxed">
                    Bent u niet tevreden met uw bestelling? Dan kunt u binnen <strong className="text-foreground">14 dagen na ontvangst</strong> contact met ons opnemen via{" "}
                    <a href="mailto:info@lunssence.com" className="text-gold hover:underline font-semibold">
                      info@lunssence.com
                    </a>
                  </p>
                </div>

                {/* Retourvoorwaarden */}
                <div>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center">
                      <ShieldCheck className="w-5 h-5 text-gold" />
                    </div>
                    <h3 className="font-serif text-2xl font-bold text-primary">Retourvoorwaarden</h3>
                  </div>
                  <ul className="space-y-3 ml-13">
                    <li className="flex items-start gap-3 text-muted-foreground">
                      <span className="text-gold mt-1">•</span>
                      <span>Retourzendingen moeten <strong className="text-foreground">ongebruikt, onbeschadigd</strong> en in de <strong className="text-foreground">originele verpakking</strong> zijn.</span>
                    </li>
                    <li className="flex items-start gap-3 text-muted-foreground">
                      <span className="text-gold mt-1">•</span>
                      <span>Om hygiënische redenen accepteren wij <strong className="text-foreground">geen retourzendingen van geopende verpakkingen</strong> van thee of kruiden.</span>
                    </li>
                    <li className="flex items-start gap-3 text-muted-foreground">
                      <span className="text-gold mt-1">•</span>
                      <span>De verzendkosten voor retourzending zijn voor <strong className="text-foreground">rekening van de klant</strong>.</span>
                    </li>
                  </ul>
                </div>

                {/* Terugbetaling */}
                <div>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center">
                      <Clock className="w-5 h-5 text-gold" />
                    </div>
                    <h3 className="font-serif text-2xl font-bold text-primary">Terugbetaling</h3>
                  </div>
                  <p className="text-muted-foreground leading-relaxed ml-13">
                    Na ontvangst en controle van het retour ontvangt u binnen <strong className="text-foreground">7 werkdagen</strong> het aankoopbedrag terug via dezelfde betaalmethode (iDEAL, Klarna of PayPal).
                  </p>
                </div>

                {/* Beschadigde levering */}
                <div>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center">
                      <Mail className="w-5 h-5 text-gold" />
                    </div>
                    <h3 className="font-serif text-2xl font-bold text-primary">Beschadigde levering</h3>
                  </div>
                  <p className="text-muted-foreground leading-relaxed ml-13">
                    Ontving u een beschadigd product? Neem binnen <strong className="text-foreground">48 uur na ontvangst</strong> contact met ons op met foto's van de schade, zodat wij dit kunnen oplossen.
                  </p>
                </div>
              </div>
            </div>

            {/* English Section */}
            <div className="bg-card rounded-2xl border-2 border-gold/20 p-8 md:p-12 shadow-lg mb-8">
              <div className="flex items-center gap-3 mb-8">
                <span className="text-4xl">🇬🇧</span>
                <h2 className="font-serif text-3xl font-bold text-primary">English</h2>
              </div>

              <div className="space-y-8">
                {/* Intro */}
                <div>
                  <p className="text-muted-foreground leading-relaxed">
                    If you are not happy with your order, please contact us within <strong className="text-foreground">14 days of receipt</strong> via{" "}
                    <a href="mailto:info@lunssence.com" className="text-gold hover:underline font-semibold">
                      info@lunssence.com
                    </a>
                  </p>
                </div>

                {/* Return Conditions */}
                <div>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center">
                      <ShieldCheck className="w-5 h-5 text-gold" />
                    </div>
                    <h3 className="font-serif text-2xl font-bold text-primary">Return Conditions</h3>
                  </div>
                  <ul className="space-y-3 ml-13">
                    <li className="flex items-start gap-3 text-muted-foreground">
                      <span className="text-gold mt-1">•</span>
                      <span>Items must be <strong className="text-foreground">unused, undamaged</strong>, and returned in their <strong className="text-foreground">original packaging</strong>.</span>
                    </li>
                    <li className="flex items-start gap-3 text-muted-foreground">
                      <span className="text-gold mt-1">•</span>
                      <span>For hygiene reasons, we <strong className="text-foreground">cannot accept returns of opened</strong> tea or herb packaging.</span>
                    </li>
                    <li className="flex items-start gap-3 text-muted-foreground">
                      <span className="text-gold mt-1">•</span>
                      <span>Return shipping costs are the <strong className="text-foreground">responsibility of the customer</strong>.</span>
                    </li>
                  </ul>
                </div>

                {/* Refunds */}
                <div>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center">
                      <Clock className="w-5 h-5 text-gold" />
                    </div>
                    <h3 className="font-serif text-2xl font-bold text-primary">Refunds</h3>
                  </div>
                  <p className="text-muted-foreground leading-relaxed ml-13">
                    Once we have received and inspected your return, your refund will be processed within <strong className="text-foreground">7 business days</strong> using the same payment method (iDEAL, Klarna, or PayPal).
                  </p>
                </div>

                {/* Damaged Delivery */}
                <div>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center">
                      <Mail className="w-5 h-5 text-gold" />
                    </div>
                    <h3 className="font-serif text-2xl font-bold text-primary">Damaged Delivery</h3>
                  </div>
                  <p className="text-muted-foreground leading-relaxed ml-13">
                    If your order arrives damaged, please contact us within <strong className="text-foreground">48 hours of receipt</strong> and include photos of the damage so we can assist you promptly.
                  </p>
                </div>
              </div>
            </div>

            {/* Contact Info */}
            <div className="bg-gradient-to-br from-gold/5 to-gold/10 rounded-2xl border border-gold/20 p-8 text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/20 mb-4">
                <Mail className="w-8 h-8 text-gold" />
              </div>
              
              <h3 className="font-serif text-2xl font-bold text-primary mb-4">
                Contact
              </h3>
              
              <div className="space-y-2 text-muted-foreground">
                <p className="flex items-center justify-center gap-2">
                  <span>📍</span>
                  <span>Lunssence – Amsterdam, Nederland</span>
                </p>
                <p className="flex items-center justify-center gap-2">
                  <span>📧</span>
                  <a href="mailto:info@lunssence.com" className="text-gold hover:underline font-semibold">
                    info@lunssence.com
                  </a>
                </p>
                <p className="flex items-center justify-center gap-2">
                  <span>🌐</span>
                  <a href="https://www.lunssence.com" className="text-gold hover:underline font-semibold">
                    www.lunssence.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};
